<template>
  <div class="mb-16">
    <CheckoutCancelPaymentModal />
    <CheckoutHeader :current-step="3" />
    <CheckoutLayout
      v-if="cart.paymentFailedExpire > 0"
      next-link="/checkout/payment"
      :title="t('checkout.payment')"
      :has-discount-code="false"
      :has-gift-card="false"
    >
    </CheckoutLayout>
  </div>
</template>

<script setup lang="ts">
  import { watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { onBeforeRouteLeave, useRouter } from 'vue-router';

  import CheckoutCancelPaymentModal from '@/components/checkout/CheckoutCancelPaymentModal.vue';
  import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
  import CheckoutLayout from '@/components/checkout/CheckoutLayout.vue';
  import { useCartStore } from '@/stores/cart';
  import { useWebsocketStore } from '@/websocket/websocket';

  const cart = useCartStore();
  const websocketStore = useWebsocketStore(); // Make sure it is open
  const { t } = useI18n();
  const router = useRouter();

  // Watch paymentFailedTimeoutFlag from cart store
  watch(() => cart.paymentFailedTimeoutFlag, (newValue) => {
    if (newValue) {
      // The flag being true means the timeout has triggered, so we route to the frontpage
      console.log('Payment failed timeout triggered, routing to frontpage');
      cart.paymentFailedTimeoutFlag = false; // reset the flag
      router.push('/');
    }
  });

  //Timeout to check if we need to load a backup unpaid order
  setTimeout(() => {
    if(cart.unpaidOrder.order && cart.unpaidOrder.order.ts == 0) {
      cart.doBackupUnpaidOrder();
    }
  }, 1000);

  onBeforeRouteLeave(() => {
    websocketStore.close();
  });

</script>
